/**
 * Generate a short, human-friendly access passcode.
 *
 * Uppercase + digits only, with visually ambiguous characters (I, O, 0, 1)
 * removed so it's easy to read off a printed QR placard and type on mobile.
 */
export function generatePasscode(length = 6): string {
  const alphabet = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
  let out = '';
  for (let i = 0; i < length; i++) {
    out += alphabet[Math.floor(Math.random() * alphabet.length)];
  }
  return out;
}
